import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PlatformIcon } from "components/icons/PlatformIcon";
import styles from "./index.module.scss";
import { PlatformId } from "views/page-content/platforms/types";
import { PlatformsTableProps } from "components/platforms/PlatformsTable";
import { PlatformSubheader } from "./PlatformSubheader";

export const PlatformsTableV2: React.FC<PlatformsTableProps> = ({
    platforms,
    connectText,
    reconnectText,
    detailsText,
    disconnectText,
    disconnectAction
}: PlatformsTableProps) => {
    const { t } = useTranslation();

    return (
        <table className="table table-sm">
            <tbody>
                {platforms
                    .filter((p) => p.Id !== PlatformId.VideoPlayer)
                    .map((p) => {
                        const subheader = PlatformSubheader({
                            platformId: p.Id as PlatformId
                        });
                        return (
                            <tr key={p.Id} className={styles["platform-row"]}>
                                <td>
                                    {!p.IsLinked ? (
                                        <div
                                            className={`${styles["platform-link"]} ${styles["disconnected"]}`}
                                        >
                                            <PlatformIcon
                                                platformId={p.Id || ""}
                                                useNewIcon={true}
                                            />
                                            <div
                                                className={
                                                    styles["platform-info"]
                                                }
                                            >
                                                {p.Name}
                                                {subheader && (
                                                    <small>
                                                        <p className="mb-2 text-muted">
                                                            {subheader}
                                                        </p>
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={`${styles["platform-link"]} ${styles["connected"]}`}
                                        >
                                            <PlatformIcon
                                                platformId={p.Id || ""}
                                                useNewIcon={true}
                                            />
                                            <div
                                                className={
                                                    styles["platform-info"]
                                                }
                                            >
                                                {p.Name}
                                                {subheader && (
                                                    <small>
                                                        <p className="mb-2 text-muted">
                                                            {subheader}
                                                        </p>
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td
                                    className={`${styles["text-right"]} text-right`}
                                >
                                    {p.IsLinked ? (
                                        p.Id ===
                                        PlatformId.Instagram ? null : p.CanManage ? (
                                            <Link
                                                className={
                                                    "btn btn-outline-tertiary"
                                                }
                                                to={p.DashboardUrl}
                                            >
                                                {detailsText}
                                            </Link>
                                        ) : (
                                            <button
                                                className="btn btn-outline-tertiary"
                                                onClick={async () => {
                                                    await disconnectAction(
                                                        p.Id as PlatformId
                                                    );
                                                }}
                                            >
                                                {disconnectText}
                                            </button>
                                        )
                                    ) : p.NeedsFacebook ? (
                                        <small className="text-muted">
                                            {t(
                                                "platforms:connect-facebook-for-instagram"
                                            )}
                                        </small>
                                    ) : (
                                        <Link
                                            className={"btn btn-primary"}
                                            to={`/platforms/connect/${p.Id}`}
                                        >
                                            {p.Id === PlatformId.Instagram
                                                ? reconnectText
                                                : connectText}
                                        </Link>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        </table>
    );
};
